import FullWidthLayout from "@/layouts/FullWidthLayout";
import SalesLeadsTable from "kinnect-front/CounterSales/SalesLeads/SalesLeadsTable";
import { Pageable } from "kinnect-mixins";
import { KTextField } from "kinnect-general";
import {
	VCard,
	VSheet
} from "vuetify/lib";

export default {
	name: "SalesLeadsPage",

	metaInfo: { title: "Sales Leads" },

	mixins: [ Pageable ],

	data: () => ( {
		search: "",
		actions: {
			add: {
				icon: "add_circle",
				text: "Add Sales Lead",
				to: { name: "salesLeadAdd" },
				tooltip: "Add a new sales lead"
			},
			completed: {
				icon: "done",
				text: "Completed",
				to: { name: "completedSalesLeads" },
				tooltip: "View completed sales leads"
			}
		}
	} ),

	computed: {
		toolbarActions() {
			if ( this.$can( "add_sales_leads" ) ) {
				return [
					this.actions.add,
					this.actions.completed
				];
			}

			return this.actions.completed;
		}
	},

	render() {
		return <FullWidthLayout>
			<VCard>
				<VSheet class="pa-3" color="primary" tile>
					<KTextField
						clearable
						dark
						flat
						hideDetails
						label="Search"
						prependInnerIcon="search"
						soloInverted
						vModel={this.search}
					></KTextField>
				</VSheet>

				<SalesLeadsTable
					itemsFilter={item => !item.completed}
					modifyItemsQuery={query => query.where( "completed", false )}
					search={this.search}
				></SalesLeadsTable>
			</VCard>
		</FullWidthLayout>;
	}
};
